<template>
  <div class="grid grid-cols-12 gap-x-10 mt-8 mb-5">
    <div class="col-span-12">
      <div class="flex items-center justify-between mb-5">
        <h5><i class="dot"></i> 부서 정보</h5>
        <div v-if="type !== 'info'">
          <vs-button color="secondary" type="border" @click="removeCompany" style="margin-right: 10px">삭제</vs-button>
          <vs-button color="secondary" @click="openPopup">추가</vs-button>
        </div>
      </div>
      <vs-table v-model="selectedCompany" @selected="handleSelected" pagination :data="companyList" class="mt-5">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th>구분</vs-th>
          <vs-th>부서명</vs-th>
          <vs-th>대표자</vs-th>
          <vs-th>담당자</vs-th>
          <vs-th>연락처</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ indextr + 1 }} </vs-td>
            <vs-td> {{ data[indextr].com_type }} </vs-td>
            <vs-td> {{ data[indextr].com_name }} </vs-td>
            <vs-td>{{ data[indextr].com_ceo }}</vs-td>
            <vs-td>{{ data[indextr].director }}</vs-td>
            <vs-td>{{ data[indextr].phone }}</vs-td>
          </vs-tr>
          <div></div>
        </template>
      </vs-table>
    </div>
    <popup-search-company v-model="showPopup" @handleClickSelect="handleClickSelect" />
  </div>
</template>

<script>
import PopupSearchCompany from "@/popup/PopupSearchCompany.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
export default {
  name: "CompanyAddModule",
  components: {
    SearchNavStartEnd,
    SearchNavItemSelect,
    PopupSearchCompany,
  },
  props: {
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: String,
  },
  data() {
    return {
      showPopup: false,
      nav: {
        selects: [
          {
            text: "1",
            value: "1",
          },
        ],
      },
      lastSelectedCompanyId: -1,
      selectedCompany: {},
      companyList: this.value,
      comTypes: [
        {
          text: "본청",
          value: "본청",
        },
        {
          text: "도급",
          value: "도급",
        },
        {
          text: "용역",
          value: "용역",
        },
        {
          text: "위탁",
          value: "본청",
        },
        {
          text: "기타",
          value: "기타",
        },
      ],
    };
  },
  watch: {
    value(data) {
      this.companyList = this.value;
    },
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    handleSelected() {
      // 토글하기 위해서, 마지막에 선택된 ID 정보를 관리한다
      if (this.lastSelectedCompanyId === this.selectedCompany.id) {
        this.selectedCompany = {};
        this.lastSelectedCompanyId = -1;
      } else {
        this.lastSelectedCompanyId = this.selectedCompany.id;
      }
      this.$emit("selected", this.selectedCompany);
    },
    handleClickSelect(company) {
      if (this.findCompanyIndex(company) <= -1) {
        this.companyList.push(company);
      }
    },
    findCompanyIndex(company) {
      let i = 0;
      for (i = 0; i < this.companyList.length; i++) {
        const com = this.companyList[i];
        if (com.id === company.id) {
          return i;
        }
      }
      return -1;
    },
    removeCompany() {
      if (this.selectedCompany && this.selectedCompany.id) {
        const index = this.findCompanyIndex(this.selectedCompany);
        if (index >= 0) {
          const company = this.companyList[index];
          this.companyList.splice(index, 1);

          this.$emit("remove", company);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;
  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}
.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.size-search {
  width: 200px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}
.search-item {
  width: 100% !important;
  margin: 0 !important;
  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }
  &::v-deep > div:last-child {
    flex: 1 !important;
    .con-select {
      width: 100%;
    }
  }
}
.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0px;
  display: inline-block;

  .vx-card__body {
    padding: 0px !important;
  }
}

span.up {
  color: #28c76f;
}
span.down {
  color: #ea5455;
}
.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
